function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50 24.9965C49.9993 20.0521 48.5325 15.219 45.785 11.1082C43.0376 6.99742 39.1329 3.79365 34.5646 1.90199C29.9964 0.0103364 24.9699 -0.48425 20.1206 0.480773C15.2713 1.4458 10.817 3.82709 7.32108 7.32354C3.82512 10.82 1.44444 15.2746 0.480094 20.124C-0.484254 24.9734 0.0110323 29.9999 1.90333 34.5679C3.79562 39.1358 6.99993 43.0401 11.1111 45.787C15.2222 48.5338 20.0556 50 25 50C28.2833 50 31.5345 49.3532 34.5679 48.0966C37.6012 46.84 40.3574 44.9982 42.6789 42.6764C45.0004 40.3546 46.8418 37.5982 48.098 34.5646C49.3541 31.5311 50.0004 28.2798 50 24.9965Z",
  fill: "#395196"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2037 19.0781V16.7108C27.2037 15.5549 27.9731 15.2869 28.5127 15.2869H31.834V10.2145L27.2594 10.1971C22.1801 10.1971 21.0277 13.9813 21.0277 16.4009V19.0781H18.1033V24.9965H21.066V39.803H26.9844V25H31.3675L31.9106 19.0816L27.2037 19.0781Z",
  fill: "white"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.7b231b1f.svg";
export { ForwardRef as ReactComponent };